import React from 'react';
import { FaEnvelope, FaLinkedinIn, FaGithub, FaWhatsapp, FaMapMarkerAlt } from 'react-icons/fa';
import SectionTitle from '../components/shared/SectionTitle';
import '../styles/about.css';

function About() {
  const tools = ['Excel', 'Power BI', 'SQL', 'Python', 'Tableau', 'Salesforce'];

  return (
    <section className="about section" id="about">
      <div className="container">
        <SectionTitle label="Who I Am" title="About Me" />
        <div className="about__grid">

          <div className="about__image-wrap">
            <div className="about__image-inner">
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80&fit=crop"
                alt="Haadi Yakubu"
              />
              <div className="about__image-badge">
                <FaMapMarkerAlt /> Wa, Ghana
              </div>
            </div>
          </div>

          <div className="about__text">
            <p>Hello! I'm <strong>Haadi Yakubu</strong> — a data analyst with a track record of turning messy datasets into clear, actionable intelligence. I combine analytical rigour with a genuine passion for community impact.</p>
            <p>My background spans <strong>logistics data management</strong>, <strong>agricultural analytics</strong>, and <strong>community development</strong>. I've worked with international organisations like the <strong>African Library Project</strong> and served as a <strong>Community Development Facilitator</strong> with CorpsAfrica.</p>
            <p>I hold a <strong>BS in Data Analytics</strong> from Blossom Academy and a <strong>BA in Public Administration</strong> from the University of Ghana, with certifications from Google, Rice University, and Johns Hopkins.</p>

            <div className="about__contact-row">
              <div className="about__contact-item">
                <FaEnvelope className="about__contact-icon" />
                <a href="mailto:hardyyaqub@gmail.com">hardyyaqub@gmail.com</a>
              </div>
              <div className="about__contact-item">
                <FaWhatsapp className="about__contact-icon" />
                <a href="https://wa.me/233556387424">+233 556 387 424</a>
              </div>
              <div className="about__contact-item">
                <FaLinkedinIn className="about__contact-icon" />
                <a href="https://www.linkedin.com/in/haadi-yakubu" target="_blank" rel="noopener noreferrer">linkedin.com/in/haadi-yakubu</a>
              </div>
              <div className="about__contact-item">
                <FaGithub className="about__contact-icon" />
                <a href="https://github.com/Hardy999" target="_blank" rel="noopener noreferrer">github.com/Hardy999</a>
              </div>
            </div>

            <div className="about__skills-preview">
              {tools.map((t) => <span className="tag" key={t}>{t}</span>)}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default About;